import { VideoCameraIcon } from '@heroicons/react/24/outline';

const fmt = (val, prefix = '', suffix = '') =>
  val !== null && val !== undefined ? `${prefix}${val.toLocaleString('en-IN')}${suffix}` : '—';

export default function SiteVisitDataSection({ gym }) {
  if (!gym) return null;

  const hasSiteData = gym.totalSqft || gym.monthlyRent || gym.activeClients;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 mt-4">
      <h3 className="text-base font-semibold text-gray-800 mb-4">Site Visit Details</h3>

      {!hasSiteData && (
        <p className="text-sm text-gray-400 italic">No site visit data recorded yet.</p>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <DataItem label="Total Area" value={fmt(gym.totalSqft, '', ' sqft')} />
        <DataItem label="Age of Gym" value={fmt(gym.ageOfGym, '', ' years')} />
        <DataItem label="Monthly Rent" value={fmt(gym.monthlyRent, '₹')} />
        <DataItem label="Cost to Operate" value={fmt(gym.cto, '₹', '/mo')} />
        <DataItem label="Active Clients" value={fmt(gym.activeClients)} />
        {gym.meetingScheduleTime && (
          <DataItem
            label="Meeting Scheduled"
            value={new Date(gym.meetingScheduleTime).toLocaleString('en-IN', {
              day: '2-digit', month: 'short', year: 'numeric',
              hour: '2-digit', minute: '2-digit'
            })}
          />
        )}
      </div>

      {gym.membershipPlans && gym.membershipPlans.length > 0 && (
        <div className="mt-4">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Membership Plans</p>
          <div className="flex flex-wrap gap-2">
            {gym.membershipPlans.map((plan, i) => (
              <span key={i} className="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full">
                {plan.name} — ₹{Number(plan.price).toLocaleString('en-IN')} / {plan.duration}
              </span>
            ))}
          </div>
        </div>
      )}

      {gym.gymVideoUrl && (
        <div className="mt-4">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Gym Video</p>
          <a
            href={gym.gymVideoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-red-600 hover:text-red-800 font-medium"
          >
            <VideoCameraIcon className="h-4 w-4" />
            Watch walkthrough video
          </a>
        </div>
      )}
    </div>
  );
}

function DataItem({ label, value }) {
  return (
    <div>
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{label}</p>
      <p className="text-sm font-semibold text-gray-800 mt-0.5">{value}</p>
    </div>
  );
}
